// extracted by mini-css-extract-plugin
export default {"block":"AccountsBlock_block__OIFnW","title":"AccountsBlock_title__DvBxh"};